import { createContext, useContext } from "react";
import invariant from "@aglocal/web/helpers/invariant";
export const MissionControlContext = createContext(null);
export function useMissionControl() {
    const api = useContext(MissionControlContext);
    invariant(api != null, "useMissionControl must be used within a MissionControlProvider");
    return api;
}
